import type {
	ArchiveOrganizationRadioChannelRequest,
	ArchiveOrganizationRadioChannelResponse,
	CreateOrganizationRadioChannelResponse,
	GetOrganizationRadioChannelsResponse,
} from "@somewear/api";
import { grpc, someGrpc } from "@somewear/grpc";
import type { ActionSetEpic } from "@somewear/model";
import { createActionSetEpicHandler } from "@somewear/model";
import { OrganizationRadioChannelRequest } from "@somewear/radio";
import { combineEpics } from "redux-observable";

import { organizationRadioChannelActions } from "./organization.radio.actions";

const getOrganizationRadioChannelsEpic: ActionSetEpic<
	void,
	GetOrganizationRadioChannelsResponse.AsObject
> = (action$, state$) => {
	return createActionSetEpicHandler(
		action$,
		state$,
		organizationRadioChannelActions.getRadioChannels,
		() => grpc.prepareRequest(someGrpc.getOrganizationRadioChannels),
	);
};

const createOrganizationRadioChannelEpic: ActionSetEpic<
	OrganizationRadioChannelRequest,
	CreateOrganizationRadioChannelResponse.AsObject
> = (action$, state$) => {
	return createActionSetEpicHandler(
		action$,
		state$,
		organizationRadioChannelActions.createRadioChannel,
		(request) =>
			grpc.prepareRequestWithPayload(someGrpc.createOrganizationRadioChannel, request.data),
	);
};

const archiveOrganizationRadioChannelEpic: ActionSetEpic<
	ArchiveOrganizationRadioChannelRequest.AsObject,
	ArchiveOrganizationRadioChannelResponse.AsObject
> = (action$, state$) => {
	return createActionSetEpicHandler(
		action$,
		state$,
		organizationRadioChannelActions.archiveRadioChannel,
		(request) =>
			grpc.prepareRequestWithPayload(someGrpc.archiveOrganizationRadioChannel, request.data),
	);
};

export const organizationRadioChannelEpics = combineEpics<any, any, any>(
	getOrganizationRadioChannelsEpic,
	createOrganizationRadioChannelEpic,
	archiveOrganizationRadioChannelEpic,
);
